"use client";

import { BRAND_CODE } from "@/config/common";
import { PriceType } from "@/utils/elevate/getPriceInfoFromProduct";
import { useMarket } from "@features/market/useMarket";
import { useSiteInfo } from "@app/_context";
import useTranslate from "@app/_hooks/useTranslate";
import { findActiveCampaigns } from "./ProductCard.utils";

export default function ProductCardBadge({
  flags,
  priceType,
  brandCodes = [],
  seriesCodes = [],
  designerCodes = [],
  categoryCodes = [],
}: {
  flags: string[];
  priceType: PriceType;
  brandCodes?: string[];
  seriesCodes?: string[];
  designerCodes?: string[];
  categoryCodes?: string[];
}) {
  const t = useTranslate();
  const market = useMarket();
  const { campaigns = [] } = useSiteInfo();

  const [campaign] = findActiveCampaigns({
    flags,
    campaigns,
    brandCodes,
    designerCodes,
    categoryCodes,
    seriesCodes,
  });

  const isCampaign =
    priceType === PriceType.campaign || priceType === PriceType.pricematch;

  const isNew =
    flags.includes("news") ||
    flags.includes(`${BRAND_CODE}_${market.countryCode}_new`);
  const isLimited = flags.includes("limited_edition");

  const campaignLabel = campaign?.campaignBadge;
  const fallbackCampaignLabel =
    isCampaign && !campaign ? t("campaignOrPricematch") : undefined;

  const labels = [
    campaignLabel,
    fallbackCampaignLabel,
    isNew ? t("new") : undefined,
    isLimited ? t("limitedEdition") : undefined,
  ].filter((label) => label && !label.startsWith("!"));

  if (!labels.length) {
    return null;
  }

  return (
    <div className="absolute top-0 left-0 grid grid-flow-row justify-items-start gap-y-1 p-3">
      {labels.map((label) => (
        <span
          key={label}
          className="all-small-caps bg-white px-2 py-1 text-xs tracking-wider uppercase"
        >
          {label}
        </span>
      ))}
    </div>
  );
}

ProductCardBadge.displayName = "ProductCardBadge";
